<template>
    <PageContainer>
        <PageHeader>
            {{ $t('stockCharge.create.page_title') }}
        </PageHeader>

        <div class="container-fluid">
            <form
                enctype="application/x-www-form-urlencoded"
                autocomplete="off"
                @submit.prevent="onVerify"
                class="row"
            >
                <div class="col-12 mb-4">
                    <button
                        class="btn btn-success me-1"
                        @click.prevent="addNewItemToForm"
                        :disabled="form.items.length > 5"
                    >
                        {{ $t('button.add_new') }}
                    </button>
                </div>

               <ChargeProductForm
                    v-for="(_, index) in form.items"
                    @removeItem="removeItem"
                    :index="index"
                    v-model:productIdModel="form.items[index].product_id"
                    v-model:sizeIdModel="form.items[index].size_id"
                    v-model:quantityModel="form.items[index].quantity"
                    :product-id-error="form.errors[`items.${index}.product_id`]"
                    :products="getProductIds"
                    :sizes="sizes"
                    :errors="getErrors(index)"
                />


                <FormActionContainer class="col-12">
                    <BackButton href="/stockCharge" />
                    <SubmitButton :disabled="form.processing" />
                </FormActionContainer>
            </form>
        </div>
    </PageContainer>

    <VerifyModal
        ref="verifyModalRef"
        @process="onProcessForm"
    />
</template>

<script setup lang="ts">
import PageHeader from "@/components/elements/PageHeader.vue";
import PageContainer from "@/components/elements/PageContainer.vue";
import BackButton from "@/components/buttons/BackButton.vue";
import {useForm} from "@inertiajs/vue3";
import SubmitButton from "@/components/buttons/SubmitButton.vue";
import FormActionContainer from "@/components/elements/FormActionContainer.vue";
import {computed, ref} from "vue";
import type {ProductInterface, SizeInterface} from "@/components/helpers/Interfaces.ts";
import ChargeProductForm from "@/components/widget/Forms/ChargeProductForm.vue";
import VerifyModal from "@/components/elements/VerifyModal.vue";

const {products, sizes} = defineProps<{
    products: Pick<ProductInterface, 'id'|'name'|'size_type'>[],
    sizes: Pick<SizeInterface, 'id' | 'size' | 'product_id'>[]
}>()

const form = useForm({
    items: [
        {
            product_id: null,
            size_id: null,
            quantity: 1
        }
    ]
})

const getErrors = computed(() => {
    return (index: number) => {
        try {
            return {
                ...(form.errors[`items.${index}.product_id`] ? {product_id: form.errors[`items.${index}.product_id`]} : {}),
                ...(form.errors[`items.${index}.size_id`] ? {size_id: form.errors[`items.${index}.size_id`]} : {}),
                ...(form.errors[`items.${index}.quantity`] ? {quantity: form.errors[`items.${index}.quantity`]} : {}),
            }
        } catch (_) {
            return {}
        }
    }
})

const getProductIds = computed(() =>{
    return products.map(item => {
        return {
            label: item.name,
            value: item.id,
            disabled: false
        }
    })
})

const addNewItemToForm = () => {
    form.items.push({
        product_id: null,
        size_id: null,
        quantity: 1
    })
}
const removeItem = (index: number) => {
    form.items.splice(index, 1)
}

const verifyModalRef = ref<InstanceType<typeof VerifyModal> |null>(null)

const onVerify = () => {
    verifyModalRef.value.openModal()
}

const onProcessForm = () => {
    verifyModalRef.value.closeModal();
    form.post('/stockCharge')
}
</script>

<style scoped>

</style>
